import React from 'react';
import '../../styles/components/CardModule.css';

const CardModule = ({ cards }) => {
  return (
    <div className="card-module-container">
      {cards.map((card, index) => (
        <a
          key={index}
          href={card.link}
          target={card.external ? "_blank" : "_self"}
          rel={card.external ? "noopener noreferrer" : ""}
          className="card-module-item"
        >
          <div className="card-module-image">
            <img src={card.image} alt={card.title} />
          </div>
          <div className="card-module-content">
            <h3 className="card-module-title">{card.title}</h3>
            <p className="card-module-description">{card.description}</p>
            <div className="card-module-meta">
              {card.date && <span className="card-module-date">{card.date}</span>}
              {card.category && <span className="card-module-category">{card.category}</span>}
            </div>
          </div>

        </a>
      ))}
    </div>
  );
};

export default CardModule; 